import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { checkPayPassCompletion, resetPayPassCompletion } from '../../actions';

export function* watchCheckPayPass() {
  yield takeEvery('CHECK_PAY_PASS', function*({ payPass }) {
    const options = {
      url: '/api/b/wallet/checkpwd',
      method: 'POST',
      data: { password: payPass },
    };
    const result = yield call(app.httpFetch, options);
    yield put(checkPayPassCompletion(result.data, result.error));
  });
}

export function* watchResetPayPass() {
  yield takeEvery('RESET_PAY_PASS', function*({ payPass, mobile, verify }) {
    const options = {
      url: '/api/b/wallet/restpwd',
      method: 'POST',
      data: { mobile, verifyCode: verify, password: payPass },
    };
    const result = yield call(app.httpFetch, options);
    app.dispatch(resetPayPassCompletion(result.data, result.error));

    if (!result.error) {
      app.showTips('succ', '支付密码重置成功');
    }
  });
}

export default function* passSaga() {
  yield all([fork(watchResetPayPass), fork(watchCheckPayPass)]);
}
